import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    if (store.getters.token) {
        config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['appType'] = 'WEB';
    let {headers = {}, isFormData = false} = config;
    if (config.method === 'get') {   // 过滤掉没有值的属性
        let params = {};
        for (let key in config.params) {
            if (config.params[key]) {
                params[key] = config.params[key];
            }
        }
        config.params = params;
    }
    const newOptions = {...config};
    if (isFormData) {
        newOptions.headers = {...headers};
        newOptions.data = toFormData(newOptions.data);

        if (
            newOptions.method === 'post' ||
            newOptions.method === 'put' ||
            newOptions.method === 'delete'
        ) {
            if (!(newOptions.data instanceof FormData)) {
                newOptions.headers = {
                    'Content-Type': 'application/json; charset=utf-8',
                    ...newOptions.headers,
                };
                newOptions.data = JSON.stringify(newOptions.data);
            } else {
                // newOptions.body is FormData
                newOptions.headers = {
                    // 'Content-Type': 'multipart/form-data',
                    ...newOptions.headers,
                };
            }
        }
    }


    return newOptions
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * code为非200是抛错 可结合自己业务进行修改
         */
        const res = response.data;
        if (res.statusCode !== 200) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 3 * 1000
            })
            // console.log(res)
            // 401:未登录;
            if (res.statusCode === 401 || res.statusCode === 408 || res.statusCode === -1) {
                MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('FedLogOut').then(() => {
                        location.reload()// 为了重新实例化vue-router对象 避免bug
                    })
                });
                return;
            }
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        console.log(error); // for debug
        // 401:未登录;
        if (error.request.statusCode === 401 || error.request.statusCode === 408) {
            store.dispatch('FedLogOut').then(() => {
                location.reload()// 为了重新实例化vue-router对象 避免bug
            })
        }

        let message = JSON.parse(error.request.response).msg;
        Message({
            message: message,
            type: 'error',
            duration: 3 * 1000
        });
        return Promise.reject(error)
    }
)

export default service


export function toFormData(params) {
    let form = new FormData();
    let keys = Object.keys(params);
    for (let key of keys) {
        if (params[key] instanceof File) {
            form.append(key, params[key]);
        } else if (params[key] instanceof String) {
            form.append(key, new Blob([params[key]], {type: 'application/json'}));
        } else if (params[key] instanceof Object) {
            form.append(key, new Blob([JSON.stringify(params[key])], {type: 'application/json'}));
        }
    }
    return form;
}




// WEBPACK FOOTER //
// ./src/utils/request.js